import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Response_dml_bean,ResponseMensaje, MensajeServicioAD } from '../model/response-dml';

import { DetParticipanteE,DetParticipanteM,MovFirmaParticipanteM } from '../model/det-participante-bean';



@Injectable({
  providedIn: 'root'
})
export class DetParticipanteService {
  baseURL = environment.urlBase;
  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;

  constructor(private httpclient:HttpClient) {}


  getfind(P_C_CONSTANCIA: string,P_C_TIPO:string,P_NOMBRE:string,P_ESTADO:string,P_CORREO:string): Observable<DetParticipanteM[]> {

    var url  : string;
    url = this.baseURL + 'participante/api/listar';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_TIPO', P_C_TIPO)
    .set('P_NOMBRE', P_NOMBRE)
    .set('P_ESTADO', P_ESTADO)
    .set('P_CORREO', P_CORREO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<DetParticipanteM[]>(url,  {headers:headers,params: params});

  }

  getfindsign(P_C_CONSTANCIA: string,P_NOMBRE:string,P_C_USUARIO:string): Observable<MovFirmaParticipanteM[]> {

    var url  : string;
    url = this.baseURL + 'participante/api/listarfirma';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_NOMBRE', P_NOMBRE)
    .set('P_C_USUARIO', P_C_USUARIO);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<MovFirmaParticipanteM[]>(url,  {headers:headers,params: params});

  }
  getsign(P_C_FIRMA: string): Observable<MovFirmaParticipanteM[]> {

    var url  : string;
    url = this.baseURL + 'participante/api/getfirma';

    let params = new HttpParams()
    .set('P_C_FIRMA', P_C_FIRMA);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<MovFirmaParticipanteM[]>(url,  {headers:headers,params: params});

  }
  get(P_C_PARTICIPANTE: string): Observable<DetParticipanteE[]> {

    var url  : string;
    url = this.baseURL + 'participante/api/get';

    let params = new HttpParams()
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<DetParticipanteE[]>(url,  {headers:headers,params: params});

  }
  insert(detParticipanteE:DetParticipanteE):Observable<Response_dml_bean>  {
    var url  : string;
    url = this.baseURL + 'participante/api/insert';

    var body : string;
    body = JSON.stringify(detParticipanteE);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.post<Response_dml_bean>(url,body,{headers});
  }
  update(detParticipanteE:DetParticipanteE):Observable<Response_dml_bean>  {
    var url  : string;
    url = this.baseURL + 'participante/api/update';

    var body : string;
    body = JSON.stringify(detParticipanteE);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.put<Response_dml_bean>(url,body,{headers});
  }
  delete(P_C_PARTICIPANTE:string):Observable<Response_dml_bean>  {
    var url  : string;
    url = this.baseURL + 'participante/api/delete';

    let params = new HttpParams()
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<Response_dml_bean>(url,{headers:headers,params:params});
  }
}
